import React, {Component} from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import each from 'lodash/each';
import get from 'lodash/get';
import uniqueId from 'lodash/uniqueId';
import Griddle from 'griddle-react';
import Confirmation from './Confirmation';

export default class SearchResultsTable extends Component {
    static propTypes = {
        checkboxes: PropTypes.bool,
        headers: PropTypes.array.isRequired,
        idGetter: PropTypes.func,
        nameGetter: PropTypes.func,
        onDelete: PropTypes.func,
        onRowClick: PropTypes.func,
        results: PropTypes.array.isRequired,
        extraColumnMetadata: PropTypes.array,
    };

    static defaultProps = {
        results: [],
        idGetter: result => result.id,
        nameGetter: result => result.name
    };

    handleDelete = (rowData) => {
        this.props.onDelete(rowData.id);
    };

    handleRowClick = ({props: {data: {id}}}) => {
        this.props.onRowClick(id);
    };

    render() {
        const {headers, results, onRowClick, idGetter, nameGetter, checkboxes, onDelete, extraColumnMetadata, ...rest} = this.props;

        if (isEmpty(headers) || !results) {
            return false;
        }
        if (isEmpty(results)) {
            return <div className="search-no-results">{'No results'}</div>;
        }
        each(headers, (head) => {
            head.cleanPath = head.path.replace(/\./g, '$');
        });
        let columns = headers.map((head) => {
            return head.cleanPath;
        });
        let columnMetadata = headers.map((head, idx) => {
            return {columnName: head.cleanPath, displayName: head.label, cssClassName: `${head.cleanPath}Col`, order: head.order || idx};
        });

        if (checkboxes) {
            const Checkbox = () => (
                <input type="checkbox" onClick={e => e.stopPropagation()}/>
            );
            columnMetadata.splice(0, 0, {columnName: 'internalCheckbox', displayName: ' ', customComponent: Checkbox});
            columns.splice(0, 0, 'internalCheckbox');
        }
        if (extraColumnMetadata) {
            columnMetadata = columnMetadata.concat(extraColumnMetadata);
            columns = columns.concat(extraColumnMetadata.map(x => x.columnName));
        }
        const showDeleteButtons = Boolean(onDelete);
        if (showDeleteButtons) {
            const DeleteButton = ({rowData}) => (
                <Confirmation
                    name={`deleteConformationModal-${uniqueId()}`}
                    bsStyle="danger"
                    onConfirm={() => this.handleDelete(rowData)}
                    componentLabel={<i className="fa fa-trash"/>}
                >
                    {`Delete ${nameGetter(rowData)}?`}
                </Confirmation>
            );
            columnMetadata = columnMetadata.concat({columnName: 'internalDelete', displayName: ' ', customComponent: DeleteButton});
            columns = columns.concat('internalDelete');
        }

        const data = results.map((result, idx) => {
            const row = {};
            const resultId = idGetter(result);
            if (checkboxes) {
                row.internalCheckbox = resultId;
            }
            if (showDeleteButtons) {
                row.internalDelete = resultId;
            }
            each(headers, (head) => {
                row[head.cleanPath] = get(result, head.path);
            });
            each(extraColumnMetadata, ecm => {
                row[ecm.columnName] = resultId;
            });
            row.id = resultId;
            row.internalIndex = idx;
            row.internalTitle = result.title;

            return row;
        });
        const SettingsIconComponent = React.createElement('i', {className: 'fa fa-cog'}, null);
        const NextArrow = React.createElement('i', {className: 'fa fa-chevron-right'}, null);
        const PreviousArrow = React.createElement('i', {className: 'fa fa-chevron-left'}, null);
        const rowMetadata = {
            bodyCssClassName: (rowData) => {
                let cls = '';
                if (onRowClick) {
                    cls = 'clickable'
                }
                if ((rowData.internalIndex % 2) === 0) {
                    cls += ' even';
                } else {
                    cls += ' odd';
                }
                return cls;
            }
        };
        return (
            <Griddle
                onRowClick={this.handleRowClick}
                results={data}
                columnMetadata={columnMetadata}
                columns={columns}
                showFilter={true}
                nextIconComponent={NextArrow}
                previousIconComponent={PreviousArrow}
                settingsIconComponent={SettingsIconComponent}
                settingsText=""
                showSettings={true}
                rowMetadata={rowMetadata}
                {...rest}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/SearchResultsTable.js